import React, { useEffect, useState, useRef } from "react";
import classNames from "classnames";
import videojs from "video.js";

export default ({
  onChange = () => {},
  height = 480,
  width = 650,
  fluid = false,
  setWebCamData,
  disposeAfterRecording = true,
}) => {
  const videoNode = useRef(null);
  const [player, setPlayer] = useState(null);
  const containerNode = useRef(null);
  const [videoJsOptions] = useState({
    controls: true,
    width,
    height,
    fluid,
    bigPlayButton: false,
    controlBar: {
      volumePanel: false,
      fullscreenToggle: false,
    },
    plugins: {
      record: {
        image: true,
        imageOutputType: "blob",
        imageOutputFormat: "image/png",
        imageOutputQuality: 0.92,
      },
    },
  });
  /**
   * Register Player On Load
   */
  useEffect(() => {
    const player = videojs(videoNode.current, videoJsOptions, () => {});

    if (setWebCamData !== undefined) {
      setWebCamData(player);
    }

    setPlayer(player);

    if (width === -1) {
      videoNode.current.style.width = "100%";
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!player) {
      return;
    }

    player.on("finishRecord", () => {
      let imageBlob = player.recordedData;
      let imageType = "image/png";
      
      if (imageBlob && imageBlob.type) {
        imageType = imageBlob.type;
      }
      
      const fileExtension = imageType.includes('png') ? '.png' : 
                           imageType.includes('jpg') || imageType.includes('jpeg') ? '.jpg' : 
                           '.png';
      
      const imageFile = new File(
        [imageBlob],
        `image_${new Date().getTime()}${fileExtension}`,
        {
          type: imageType,
          lastModified: new Date()
        }
      );

      if (disposeAfterRecording) {
        player.dispose();
      }

      onChange(imageFile);
    });
  }, [player, onChange, disposeAfterRecording]);


  // function blobToFile(theBlob, fileName) {
  //   A Blob() is almost a File() - it's just missing the two properties below which we will add
  //   theBlob.lastModifiedDate = new Date();
  //   theBlob.name = fileName;
  //   return theBlob;
  // }

  return (
    <div data-vjs-player ref={containerNode}>
      <video
        id="myVideo"
        ref={videoNode}
        preload="metadata"
        className={classNames({
          "video-js vjs-default-skin": true,
          imageRecorder: true,
        })}
        playsInline
      ></video>
    </div>
  );
};
